<template>
	<layout v-bind="{disabled, unit}">
		<input class="input" type="text" v-bind="{disabled, placeholder}" v-model="val" @input="update(val)"/>
	</layout>
</template>

<script>
import layout from "./layout/input.vue";

export default {
	components: {layout},
	props: {
		unit: {type: String, required: false},
		value: {type: String, required: false},
		disabled: {type: Boolean, required: false}
	},
	data() {
		return {
			placeholder: "...",
			val: this.value
		}
	},
	methods: {
		update(value) {
			this.$emit("update", value);
		}
	}
};
</script>
